import React from 'react';

interface ButtonProps {
  type?: 'button' | 'submit';
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
}

const Button: React.FC<ButtonProps> = ({ type = 'button', onClick, children, variant = 'primary' }) => {
  // Base button styles with fixed width to ensure all buttons are the same size
  const baseClass = 'py-2 px-6 max-w-xs rounded-lg text-sm font-semibold focus:outline-none transition duration-300 text-center';

  // Variants
  const primaryClass = 'bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800 focus:ring-2 focus:ring-blue-500';
  const secondaryClass = 'bg-gray-600 text-white hover:bg-gray-700 active:bg-gray-800 focus:ring-2 focus:ring-gray-500';

  // Combine base and variant-specific classes
  const buttonClass = variant === 'primary' ? `${baseClass} ${primaryClass}` : `${baseClass} ${secondaryClass}`;

  return (
    <button
      type={type}
      onClick={onClick}
      className={buttonClass}
    >
      <span className="truncate">{children}</span>
    </button>
  );
};

export default Button;
